<template>
  <input
    ref="inputRef"
    :disabled="props.disabled"
    placeholder="0.00"
    class="w-full p-2 box-border font-bold h-20 focus:outline-none text-slate-600 text-center tracking-tighter currency-input"
    :style="{ fontSize: fontSize + 'px' }"
    @change="onChange"
    data-testid="currency"
  />
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref, watch } from 'vue';
import { CurrencyDisplay, useCurrencyInput } from 'vue-currency-input';

const props = withDefaults(
  defineProps<{
    modelValue: number;
    disabled?: boolean;
    min?: number;
    max?: number;
  }>(),
  {
    min: 0,
    max: 9999999.99,
  },
);

const options = {
  currency: 'ZAR',
  currencyDisplay: CurrencyDisplay.symbol,
  hideCurrencySymbolOnFocus: false,
  hideGroupingSeparatorOnFocus: false,
  autoDecimalDigits: true,
  locale: 'en-ZA',
  valueRange: {
    min: props.min,
    max: props.max,
  },
};

const { inputRef, formattedValue } = useCurrencyInput(options);
const amount = ref(props.modelValue);
const fontSize = ref(10);

const onChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.value;
  amount.value = parseFloat(value);
};

const adjustFontSize = () => {
  const minFontSize = 10;
  const maxFontSize = 40;
  if (inputRef.value) {
    const inputWidth = inputRef.value.clientWidth + 300;
    const length = formattedValue.value?.length || 1;
    const textLength = length > 10 ? length : 1;
    fontSize.value = Math.max(minFontSize, Math.min(inputWidth / textLength, maxFontSize));
  }
};

watch(formattedValue, () => {
  adjustFontSize();
});

onMounted(() => {
  adjustFontSize();
  nextTick(() => inputRef.value?.blur());
});
</script>
